var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#94BE43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.8889L19.3846 32L36 16",
    stroke: "white",
    strokeWidth: 2.07692
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreation);
export default __webpack_public_path__ + "static/media/creation.1e61b3f482b6d19db789974a1437ea6c.svg";
export { ForwardRef as ReactComponent };